import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import API from 'services/API';
import { sendRequest } from 'services/utils';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';

export const getActivityLogTypes = async () => {
  const allowedActivityTypesIds = {
    Email: 1,
    Text: 2,
    Call: 3
  };

  try {
    const response = await API.get(Endpoints.ActivityTypes);

    if (response.status !== HTTPStatusCodes.Ok) return [];

    return response.data.filter(({ id }) => Object.values(allowedActivityTypesIds).includes(id));
  } catch (error) {
    return [];
  }
};

/**
 * @param {number} candidateId
 * @param {UrgencyVerificationPayload} payload
 * @returns {Promise<OperationResult>}
 */
export const saveCandidateUrgencyVerification = async (candidateId, payload) =>
  sendRequest(
    Endpoints.UrgencyVerificationCandidates.replace(':id', candidateId),
    'put',
    payload,
    strings.inventory.urgencyVerification.results.candidate
  );

/**
 * @param {number} jobOrderId
 * @param {UrgencyVerificationPayload} payload
 * @returns {Promise<OperationResult>}
 */
export const saveJobOrderUrgencyVerification = async (jobOrderId, payload) =>
  sendRequest(
    Endpoints.UrgencyVerificationJobOrders.replace(':id', jobOrderId),
    'put',
    payload,
    strings.inventory.urgencyVerification.results.jobOrder
  );

/**
 * @param {string} candidateId
 */
export const getCandidateUrgencyVerification = async candidateId => {
  try {
    const results = await API.get(
      Endpoints.UrgencyVerificationCandidates.replace(':id', candidateId)
    );
    return results?.data;
  } catch (error) {
    return null;
  }
};

/**
 * @param {string} jobOrderId
 */
export const getJobOrderUrgencyVerification = async jobOrderId => {
  try {
    const results = await API.get(
      Endpoints.UrgencyVerificationJobOrders.replace(':id', jobOrderId)
    );
    return results?.data;
  } catch (error) {
    return null;
  }
};
